import React, { useState, useEffect } from 'react';
import moment from 'moment'
import {getOldestEvent} from '../data-source/storedEvents'
import {getFirstEvent} from '../data-source/newEvents'

const PeriodSelector = ({year,setYear,month,setMonth,disabled,errorHandler}) => {
    
    const [yearDropdownVisible,setYearDropdownVisible] = useState(false)
    const [monthDropdownVisible,setMonthDropdownVisible] = useState(false)
    const [earliestDate, setEarliestDate] = useState({year: parseInt(moment().format('YYYY')), month: parseInt(moment().format('M'))})
    const thisYear = parseInt(moment().format("YYYY"))
    
    useEffect( () => {
        const existingPromise = getOldestEvent()
        const unclaimedPromise = getFirstEvent()
        Promise.all([existingPromise,unclaimedPromise])
            .then( values => {
                const earliestExistingMoment =  values[0].length > 0 ? moment(values[0][0].date) : moment()
                const earliestUnclaimedMoment = typeof values[1].utc !== 'undefined' ? moment(values[1].utc) : moment()
                const earliestMoment = earliestExistingMoment.isBefore(earliestUnclaimedMoment) ? earliestExistingMoment : earliestUnclaimedMoment

                setEarliestDate({
                    year: earliestMoment.format('YYYY'),
                    month: earliestMoment.format('M')
                })
            })
            .catch( error => {
                console.log(error)
                errorHandler( error )
            })

    }, [errorHandler])

    

    const handleChangeYear = newYear => {
        setYear(newYear)
    }

    const handleChangeMonth = newMonth => {
        setMonth( newMonth === 0 ? "All" : newMonth )
    }

    useEffect( () => {
        setYearDropdownVisible(false)
        setMonthDropdownVisible(false)
    },[year,month])

    useEffect( () => {
        if(yearDropdownVisible) setMonthDropdownVisible(false);
    },[yearDropdownVisible])
    useEffect( () => {
        if(monthDropdownVisible) setYearDropdownVisible(false);
    },[monthDropdownVisible])

    let years = []
    for(let y=earliestDate.year;y<=thisYear;y++){
        years.push({year: y.toString(), selected: year===y})
    }

    let months = ["All","January","February","March","April","May","June","July","August","September","October","November","December"]

    const yearButtons = years.reverse().map( obj => {
        return(
            // eslint-disable-next-line
            <a className="dropdown-item" href="#" key={obj.year} onClick={ () => handleChangeYear(obj.year) }>{obj.year}</a>
        )
    })

    const monthButtons = months.map( (m,key) => {
        return(
            // eslint-disable-next-line
            <a className="dropdown-item" href="#" key={m} onClick={ () => handleChangeMonth(key) }>{m}</a>
        )
    })
        
    return(
        <div className="btn-group" role="group" aria-label="Select period">
            <div className="btn-group" role="group" aria-label="Select period">
                <button 
                    id="yearButtonGroup" 
                    type="button" 
                    className="btn btn-outline-secondary dropdown-toggle" 
                    aria-haspopup="true" 
                    aria-expanded="false"
                    onClick={() => setYearDropdownVisible(!yearDropdownVisible)}
                    disabled={disabled}>
                    {year}
                </button>
                <div className="dropdown-menu" aria-labelledby="Select Year" style={{display: yearDropdownVisible ? "block" : "none"}}>
                    {yearButtons}
                </div>
            </div>
            <div className="btn-group" role="group" aria-label="Select period">
                <button 
                    id="monthButtonGroup" 
                    type="button" 
                    className="btn btn-outline-secondary dropdown-toggle" 
                    aria-haspopup="true" 
                    aria-expanded="false"
                    onClick={() => setMonthDropdownVisible(!monthDropdownVisible)}
                    disabled={disabled}>
                    {month === "All" ? "All" : months[month]}
                </button>
                <div className="dropdown-menu" aria-labelledby="Select Year" style={{display: monthDropdownVisible ? "block" : "none"}}>
                    {monthButtons}
                </div>
            </div>       
        </div>
    );
}

export default PeriodSelector